/**
 * Product-specific configuration.
 * VITE_PRODUCT is set via env files (e.g. .env.mdsync.local, .env.notalo.local).
 */
const product =
  (import.meta.env.VITE_PRODUCT as string | undefined) ?? "mdsync";

export const PRODUCT = product;

/** Whether the AI chat experience is shown. Hidden for mdsync. */
export const isAiChatEnabled = product !== "mdsync";
